import { type FC } from 'react';
import {
  useDisclosure
} from '@chakra-ui/react';
import {
  type UiHStackProps,
  UiIconPlusCircle,
  uiStyles,
  UiHStack,
  UiText
  // UiGrid,
} from '@/lib/ui';
import BaseButtonIconText from '@/base/Button/IconText';
import LocaleForm from '@/registration/buildEvent/Locales/LocaleForm';

export interface NewLocaleProps extends UiHStackProps {}

const NewLocale: FC<NewLocaleProps> = () => {
  const { isOpen, onToggle } = useDisclosure();
  return (
    <>
      <BaseButtonIconText Icon={UiIconPlusCircle} onClick={onToggle}>Add locale</BaseButtonIconText>
      <LocaleForm
        onClose={onToggle}
        isVisible={isOpen}
        onSaveSuccess={() => {}}
      />
    </>
  );
};

export default NewLocale;
